/* Essence: engraving add/edit inside the cart drawer. Loaded from layout/theme.liquid. */
if (!window.customElements.get('cart-line-engraving')) {
      class CartLineEngraving extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-engraving-open]');
          this.editor = this.querySelector('[data-engraving-editor]');
          this.input = this.querySelector('[data-engraving-input]');
          this.count = this.querySelector('[data-engraving-count]');
          this.error = this.querySelector('[data-engraving-error]');
          this.toggle.addEventListener('click', () => {
            const open = this.editor.hasAttribute('hidden');
            this.editor.toggleAttribute('hidden', !open);
            this.toggle.setAttribute('aria-expanded', String(open));
            if (open) this.input.focus();
          });
          this.input.addEventListener('input', () => { this.count.textContent = this.input.value.length; });
          this.querySelector('[data-engraving-save]').addEventListener('click', () => this.save(this.input.value.trim()));
          const remove = this.querySelector('[data-engraving-remove]');
          if (remove) remove.addEventListener('click', () => this.save(''));
        }
        async save(value) {
          let props = {};
          try { const raw = JSON.parse(this.dataset.properties || '{}'); if (Array.isArray(raw)) { raw.forEach(pair => { if (Array.isArray(pair) && pair.length === 2) props[pair[0]] = pair[1]; }); } else if (raw && typeof raw === 'object') { props = raw; } } catch (e) {}
          if (value) { props['Engraving Text'] = value; } else { props['Engraving Text'] = ''; }
          this.setAttribute('data-busy', '');
          this.error.setAttribute('hidden', '');
          try {
            const res = await fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: this.dataset.lineKey, quantity: Number(this.dataset.quantity), properties: props })
            });
            if (!res.ok) throw new Error('cart change failed');
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('on:cart:change'));
            if (!document.querySelector('cart-drawer')) window.location.reload();
          } catch (e) {
            this.error.removeAttribute('hidden');
            this.removeAttribute('data-busy');
          }
        }
      }
      window.customElements.define('cart-line-engraving', CartLineEngraving);
    }
